import { injectable, inject } from 'inversify';
import { CreateCartUseCase } from '../../../domain/usecases/SaleUseCases';
import type { CartRepository } from '../../../domain/repositories';
import { Cart } from '../../../domain/models';
import { TYPES } from '../../../di/types';

/**
 * Implementation of CreateCartUseCase
 * This contains the business logic for creating new carts
 */
@injectable()
export class CreateCartUseCaseImpl implements CreateCartUseCase {
  constructor(
    @inject(TYPES.CartRepository) private readonly cartRepository: CartRepository
  ) {}

  async execute(cashierId: string, branchId: string): Promise<Cart> {
    try {
      // Validate parameters
      this.validateParameters(cashierId, branchId);

      // Create empty cart data
      const cartData = {
        branchId: branchId,
        userId: cashierId,
        items: [],
        discountPercentage: 0,
        subtotal: 0,
        discountAmount: 0,
        totalAmount: 0,
        customerId: undefined
      };

      // Create cart through repository
      const cart = await this.cartRepository.create(cartData);

      console.log(`✅ Cart created successfully: ${cart.id} for cashier ${cashierId} in branch ${branchId}`);
      return cart;
    } catch (error) {
      console.error('Create cart failed:', error);
      throw error;
    }
  }

  private validateParameters(cashierId: string, branchId: string): void {
    if (!cashierId || cashierId.trim().length === 0) {
      throw new Error('Cashier ID is required');
    }

    if (!branchId || branchId.trim().length === 0) {
      throw new Error('Branch ID is required');
    }
  }
} 